// Format amount in CFA
export const formatCurrency = (amount: number | undefined | null) => {
  if (amount == null) return '0 FCFA';
  return `${amount.toLocaleString('fr-FR')} FCFA`;
};

// Calculate daily payment
export const calculateDailyPayment = (totalAmount: number, downPayment: number, months: number) => {
  const remainingAmount = totalAmount - downPayment;
  const days = months * 30;
  return Math.ceil(remainingAmount / days);
};